module.exports = __webpack_public_path__ + "img/circle-unchecked.4a1f6171.svg";